import dynamic from 'next/dynamic'
export const Map = dynamic(() => import('./map-component'), { ssr: false })
export const MapFullWidth = dynamic(() => import('./map-full-width'), { ssr: false })
